import React from "react";
import ResultInfoText from "./ResultInfoText.js";
import { faArrowRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InteractiveImage from "../ReactionTable/interactiveImage.js";
import MoleculeInfo from "./MoleculeInfo.js";
import { Link } from "react-router-dom";

function ReactionDisplay({ table, row, interactiveSearch, isQuickSearch, interactiveAdvancedSearch, showSubstratePopups, maxWidth="70px", imageScale="3.0", displayTextCol=false }) {
  return (
    <div class="reaction-div">
        {table[row].substrates.map((substrate, index) => (
                <>
                {displayTextCol ? (
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}> 
                    <Link to={`/record/${substrate.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>                     
                        <InteractiveImage src={`/mol_${substrate.id}.png`}
                            alt={substrate.smiles}
                            className={"responsive"}
                            interactiveSearch={interactiveSearch}
                            showPopups={showSubstratePopups}
                            interactiveAdvancedSearch={() => {}}
                            isQuickSearch={true}
                            parameter={"reactSmiles"}
                            maxWidth={maxWidth}
                            imageScale={imageScale}/>
                          <MoleculeInfo molecule={substrate} interactiveSearch={interactiveSearch}/>
                    </Link>
                    </div>
                ) : (
                  <>
                    <MoleculeInfo molecule={substrate} interactiveSearch={interactiveSearch}/>
                    <Link to={`/record/${substrate.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <InteractiveImage src={`/mol_${substrate.id}.png`}
                        alt={substrate.smiles}
                        className={"responsive"}
                        interactiveSearch={interactiveSearch}
                        showPopups={showSubstratePopups}
                        interactiveAdvancedSearch={() => {}}
                        isQuickSearch={true}
                        parameter={"reactSmiles"}
                        maxWidth={maxWidth}
                        imageScale={imageScale}/>
                    </Link>
                  </>
                )}
                {index < table[row].substrates.length - 1 && <FontAwesomeIcon icon={faPlus} />}
                </>
        ))}
        <FontAwesomeIcon icon={faArrowRight} />

        {displayTextCol ? ( <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        <Link to={`/record/${table[row].product.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>
          <InteractiveImage src={`/mol_${table[row].product.id}.png`}
                    alt={table[row].product.smiles}
                    className={"responsive"}
                    interactiveSearch={interactiveSearch}
                    showPopups={showSubstratePopups}
                    interactiveAdvancedSearch={() => {}}
                    isQuickSearch={true}
                    parameter={"reactSmiles"}
                    maxWidth={maxWidth}
                    imageScale={imageScale}/>
        </Link>
        <MoleculeInfo molecule={table[row].product} interactiveSearch={interactiveSearch} /> </div> ) : (<>
        <Link to={`/record/${table[row].product.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <InteractiveImage src={`/mol_${table[row].product.id}.png`}
                    alt={table[row].product.smiles}
                    className={"responsive"}
                    interactiveSearch={interactiveSearch}
                    showPopups={showSubstratePopups}
                    interactiveAdvancedSearch={() => {}}
                    isQuickSearch={true}
                    parameter={"reactSmiles"}
                    maxWidth={maxWidth}
                    imageScale={imageScale}/>
        </Link>
        <MoleculeInfo molecule={table[row].product} interactiveSearch={interactiveSearch} /> </>)}
    </ div>    
  );
}

export default ReactionDisplay;